import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { OrderService } from "../../core/services/order.service";
import { GyzmoButtonModule } from "../../gyzmo-commons/components/gyzmo-button/gyzmo-button.module";
import { IriumTitleModule } from "../../gyzmo-commons/components/irium-title/irium-title.module";
import { PipesModule } from "../../gyzmo-commons/helpers/pipes/pipes.module";
import { ConstructionSiteCardModule } from "../components/construction-site-card/construction-site-card.module";
import { ContractCardModule } from "../components/contract-card/contract-card.module";
import { CustomerCardComponentModule } from "../components/customer-card/customer-card.module";
import { MaterialLineDepartureMatidModule } from "../components/material-line-departure-matid/material-line-departure-matid.module";
import { MaterialLineDepartureMatqtConsoModule } from "../components/material-line-departure-matqt-conso/material-line-departure-matqt-conso.module";
import { TitleBarModule } from "../components/title-bar/title-bar.module";
import { DepartureSignatureModule } from "../popovers/departure-signature/departure-signature.module";
import { DeparturePage } from "./departure.page";

@NgModule(
    {
        declarations: [
            DeparturePage,
        ],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            PipesModule,
            TranslateModule,
            RouterModule.forChild([
                {
                    path: "",
                    component: DeparturePage,
                },
            ]),
            ConstructionSiteCardModule,
            ContractCardModule,
            CustomerCardComponentModule,
            TitleBarModule,
            DepartureSignatureModule,
            GyzmoButtonModule,
            IriumTitleModule,
            MaterialLineDepartureMatidModule,
            MaterialLineDepartureMatqtConsoModule,
        ],
        exports: [
            DeparturePage,
        ],
        providers: [
            OrderService,
        ],
    })

export class DeparturePageModule {
}
